import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import type { ErrorInfo } from '@/types/error';

interface ErrorState {
	error: ErrorInfo | null;
	setError: (error: ErrorInfo) => void;
	clearError: () => void;
}

const initialState: ErrorState = {
	error: null,
	setError: () => {},
	clearError: () => {},
};

export const useErrorStore = create<ErrorState>()(
	devtools(
		(set) => ({
			...initialState,
			setError: (error: ErrorInfo) => {
				set({ error }, false, 'error/setError');
			},
			clearError: () => {
				set({ error: null }, false, 'error/clearError');
			},
		}),
		{ name: 'ErrorStore' },
	),
);

